var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStomach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182 6s-32 75-18 141 41 107 45 120c4 12 11 75 0 96s-41 16-78 4-34-16-59-14-62 25-64 50 0 86 0 86h45l2-36s-2-45 34-21c36 23 93 111 219 59 127-52 153-126 153-190s-26-168-92-182-86-9-114 18c-29 27-37 36-46 32s-23-34-18-68 25-89 25-89l-32-4zm95 322s-24 81-55 96c-30 15-66 13-42 25 25 11 39 27 117-6 78-32 120-114 120-114l-140-2zm-36-117s20 107 5 152c-14 45-57 55-82 55s-2 50 48 59 144-32 180-77 59-96 37-159c-21-62-39-93-93-96-54-4-84 23-96 66z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStomach);
export default __webpack_public_path__ + "static/media/stomach.cbb6257336797e776df3b4b42ad85811.svg";
export { ForwardRef as ReactComponent };